import ApiService from "@/common/api/api.service";

const ContratoDocumentacao = {

    salvarContratoDocumentacao(form) {
        return ApiService.post(`ProjetoGestao/comprovante-arquivos`, form);
    },

    listarContratoDocumentacao(id) {
        return ApiService.get(`ProjetoGestao/comprovante-arquivos?ProjetoGestaoId=${id}`);
    },
    
    excluirContratoDocumentacao(id) {
        return ApiService.delete(`ProjetoGestao/comprovante-arquivos?id=${id}`);
    }


}

export default ContratoDocumentacao;
